import { render, staticRenderFns } from "./AvailabilityManagement.vue?vue&type=template&id=b6c267b2&scoped=true"
import script from "./AvailabilityManagement.vue?vue&type=script&lang=ts"
export * from "./AvailabilityManagement.vue?vue&type=script&lang=ts"
import style0 from "./AvailabilityManagement.vue?vue&type=style&index=0&id=b6c267b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c267b2",
  null
  
)

export default component.exports